import { Field } from 'formik';
import at from 'lodash/at';
import PropTypes from 'prop-types';
import React from 'react';
import { Input } from 'styleguide';

export const SelectField = ({
  field: { onBlur, ...field }, // { name, value, onChange, onBlur }
  form: { touched, errors, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...otherProps
}) => {
  const wasTouched = at(touched, [field.name])[0];
  const error = at(errors, [field.name])[0];

  const onChange = (value) => setFieldValue(field.name, value);

  return (
    <Input
      {...field}
      type="select"
      invalid={error && wasTouched}
      errorMessage={wasTouched && error}
      setFieldValue={setFieldValue}
      onChange={onChange}
      {...otherProps}
    />
  );
};

SelectField.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
};

export default (props) => <Field component={SelectField} {...props} />;
